import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ModalModule } from 'ngx-bootstrap/modal';
import { httpInterceptor } from './interceptors/http.interceptor';
export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(withInterceptors([httpInterceptor])),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(),
        provideToastr(),
        importProvidersFrom(BrowserAnimationsModule),
        importProvidersFrom(CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        })),
        importProvidersFrom(ModalModule.forRoot())
    ]
};